import { load } from "../localStorage"

const GLOBAL_STORAGE_KEY = "data"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState(field) {
    if (this.formValues[field] === undefined) {
      return false
    }
    this.showButton = this.formValues[field].length > 0
  },

  populateFormValuesFromStorage(values) {
    const globalData = load(GLOBAL_STORAGE_KEY)

    values.map((value) => {
      const globalMatch = globalData.values[value]

      if (!globalMatch) return

      this.formValues[value] = globalMatch
    })

    this.getButtonState(values[0])
  },

  isDisabled(values, exclusiveValue, currentValue) {
    if (!values || values.length === 0 || !values.includes(exclusiveValue)) return false

    return exclusiveValue === currentValue ? false : true
  },

  handleSelection(field, exclusiveValue, title) {
    if (title === exclusiveValue) {
      this.formValues[field] = this.formValues[field].includes(exclusiveValue)
        ? []
        : [exclusiveValue]
    } else {
      if (this.formValues[field].includes(title)) {
        this.formValues[field].splice(this.formValues[field].indexOf(title), 1)
      } else {
        this.formValues[field].push(title)
      }
    }
  },
})
